import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { TiptapButton } from '../../TiptapButton';

export const AddColumnAfterButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().addColumnAfter().run()}
         icon={<FontAwesomeIcon icon={faArrowRight} />}
         title={_js('Add column to the right')}
         isDisabled={!editor.can().addColumnAfter()}
      />
   );
};
